module.exports = __webpack_public_path__ + "static/media/home-hero--bg-newyork.ddce1bfa.jpg";